import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=f22b6150&scoped=true&"
import script from "./user-detail.vue?vue&type=script&lang=js&"
export * from "./user-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./user-detail.vue?vue&type=style&index=1&id=f22b6150&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22b6150",
  null
  
)

export default component.exports